import React from "react";
import { AppRoutes } from "../../routes/AppRouter";
import EditModelButton from "../components/ai/models/EditModelButton";
import EditPriceButton from "../components/ai/models/EditPriceButton";
import ModelManagement from "../components/ai/models/ModelManagement";
import PriceManagement from "../components/ai/models/PriceManagement";
import EditSkillButton from "../components/ai/skills/EditSkillsButton";
import SkillManagement from "../components/ai/skills/SkillManagement";
import Page from "../components/container/Page";
import AsAdmin from "../components/session/AsAdmin";
import GeneralSettings from "../components/settings/GeneralSettings";
import Tabs, { Tab } from "../components/tabs/Tabs";

export enum ADMIN_TAB {
  SKILLS = "SKILLS",
  MODELS = "MODELS",
  PRICES = "PRICES",
  LIMITS = "LIMITS"
}

export const AdminTabLabelMap: Record<ADMIN_TAB, string> = {
  [ADMIN_TAB.SKILLS]: "Skills",
  [ADMIN_TAB.MODELS]: "Models",
  [ADMIN_TAB.PRICES]: "Prices",
  [ADMIN_TAB.LIMITS]: "Limits"
};

export default function AdminAreaPage() {

  const [tab, setTab] = React.useState<ADMIN_TAB>(ADMIN_TAB.SKILLS);

  const actions = () => {
    switch (tab) {
      case ADMIN_TAB.MODELS: return <EditModelButton />;
      case ADMIN_TAB.PRICES: return <EditPriceButton />;
      case ADMIN_TAB.SKILLS: return <EditSkillButton />;
      // limits save through their own form
      default: return undefined;
    }
  }

  const content = () => {
    switch (tab) {
      case ADMIN_TAB.MODELS: return <ModelManagement />;
      case ADMIN_TAB.PRICES: return <PriceManagement />;
      case ADMIN_TAB.LIMITS: return <GeneralSettings />;
      default: return <SkillManagement />;
    }
  }

  return (
    <AsAdmin>
      <Page
        title={AppRoutes.AdminArea.Label}
        subtitle={AppRoutes.AdminArea.Subtitle}
        actions={actions()}
      >
        <div className="d-flex flex-column h-100 w-100">
          <Tabs
            size="small"
            active={tab}
            onClick={(t: ADMIN_TAB) => setTab(t)}
          >
            {
              Object.values(ADMIN_TAB).map(t => (
                <Tab value={t} key={t}>
                  {AdminTabLabelMap[t]}
                </Tab>
              ))
            }
          </Tabs>
          {
            content()
          }
        </div>
      </Page>
    </AsAdmin>
  )
}
